
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 39.21 39.21"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"cx":"19.6","cy":"19.6","r":"19.6","fill":"#f04747"}}),_c('path',{attrs:{"fill":"#fff","d":"M19.6 23.41L7.41 10.76l3.61-3.49 8.58 8.9 8.59-8.9 3.61 3.49-12.2 12.65z"}}),_c('path',{attrs:{"fill":"#fff","d":"M28.22 31.97l-8.62-8.63-8.61 8.63-3.55-3.55L19.6 16.23l12.17 12.19-3.55 3.55z"}})])
          )
        }
      }
    